import { LEGAL_LINKS } from '../constants/profileMenu.constants';
import {
	LegalGrid,
	LegalLink,
	Links,
	MailIcon,
	SupportCopy,
	SupportEmail,
	SupportLabel,
	SupportRow,
} from '../ProfileMenu.styles';
import MailGlyph from './MailGlyph';

const ProfileMenuFooter = ({
	privacyPolicyLabel,
	termsOfUseLabel,
	supportLabel,
	supportEmail,
}) => (
	<Links>
		<LegalGrid>
			<LegalLink
				href={LEGAL_LINKS.privacy}
				target="_blank"
				rel="noopener noreferrer"
			>
				{privacyPolicyLabel}
			</LegalLink>
			<LegalLink
				href={LEGAL_LINKS.terms}
				target="_blank"
				rel="noopener noreferrer"
			>
				{termsOfUseLabel}
			</LegalLink>
		</LegalGrid>
		<SupportRow href={`mailto:${supportEmail}`}>
			<MailIcon>
				<MailGlyph />
			</MailIcon>
			<SupportCopy>
				<SupportLabel>{supportLabel}</SupportLabel>
				<SupportEmail>{supportEmail}</SupportEmail>
			</SupportCopy>
		</SupportRow>
	</Links>
);

export default ProfileMenuFooter;
